import React from 'react';
import { Helmet } from 'react-helmet';
export function SEOHead() {
  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    name: 'TTVIP SG',
    description: '新加坡顶级伴游服务，十年匠心，尊享体验。精选日韩、欧美、越南、中国佳丽，24/7专属预约。',
    url: 'https://ttvip.life',
    telephone: '',
    address: {
      '@type': 'PostalAddress',
      addressLocality: 'Singapore',
      addressCountry: 'SG'
    },
    foundingDate: '2015',
    aggregateRating: {
      '@type': 'AggregateRating',
      ratingValue: '4.9',
      reviewCount: '5000'
    }
  };
  return <Helmet data-id="element-70">
      {/* Primary Meta */}
      <title data-id="element-71">
        TTVIP SG顶级伴游服务 | 新加坡精选日韩欧美越南中国佳丽 | Singapore
        Premier Companion
      </title>
      <meta name="description" content="TTVIP — 新加坡顶级伴游服务品牌，十年匠心，尊享体验。严选200+日韩佳丽、欧美佳丽、越南佳丽、中国佳丽，5000+尊贵客户信赖，99%好评率。24/7 Telegram专属预约，Singapore's Premier Companion Service since 2015." data-id="element-72" />
      <meta name="keywords" content="TTVIP, 新加坡伴游, Singapore companion, 顶级伴游服务, 新加坡佳丽, 日韩佳丽, 欧美佳丽, 越南佳丽, 中国佳丽, premium escort Singapore, Singapore elite companion, 新加坡高端伴游, SG伴游, Japanese Korean companion Singapore, Western companion Singapore, Vietnamese companion Singapore, Chinese companion Singapore, Telegram预约, 24/7预约" data-id="element-73" />
      <meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large" data-id="element-74" />
      <meta name="author" content="TTVIP SG" data-id="element-75" />
      <link rel="canonical" href="https://www.geylang777-5.site/" data-id="element-76" />

      {/* Language & Geo */}
      <html lang="zh-CN" data-id="element-77" />
      <meta httpEquiv="content-language" content="zh-CN, en" data-id="element-78" />
      <meta name="geo.region" content="SG" data-id="element-79" />
      <meta name="geo.placename" content="Singapore" data-id="element-80" />

      {/* Open Graph */}
      <meta property="og:type" content="website" data-id="element-81" />
      <meta property="og:url" content="https://www.geylang777-5.site/" data-id="element-82" />
      <meta property="og:title" content="TTVIP SG顶级伴游服务 | 新加坡精选佳丽 · 十年匠心" data-id="element-83" />
      <meta property="og:description" content="严选200+日韩、欧美、越南、中国顶级佳丽，5000+客户信赖，99%好评。十年匠心打造新加坡顶级伴游品牌，24/7 Telegram专属预约。" data-id="element-84" />
      <meta property="og:site_name" content="TTVIP SG" data-id="element-85" />
      <meta property="og:locale" content="zh_CN" data-id="element-86" />
      <meta property="og:locale:alternate" content="en_SG" data-id="element-87" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" data-id="element-88" />
      <meta name="twitter:title" content="TTVIP SG顶级伴游服务 | Singapore Premier Companion" data-id="element-89" />
      <meta name="twitter:description" content="新加坡顶级伴游品牌，严选200+精选佳丽，十年匠心，5000+客户好评。24/7 Telegram预约。" data-id="element-90" />

      {/* Structured Data */}
      <script type="application/ld+json" data-id="element-91">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>;
}